import React from "react";
import { useTranslation } from "react-i18next";
import "./FullScreenLoader.css";
import logo from "../../assets/legup-logo.svg";

export default function LegUpLoader({ text }) {
  const { t } = useTranslation("common");

  return (
    <div className="legup-loader">
      <div className="legup-loader__card">
        <img src={logo} alt="LEG-UP" className="legup-loader__logo" />

        <div className="legup-loader__ring" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>

        <p className="legup-loader__text">
          {text || t("loader.preparingDashboard")}
        </p>
      </div>
    </div>
  );
}
